import {TitleCasePipe} from '@angular/common';
import {Component, Inject, OnInit} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';
import {ShowDialogsComponent} from 'src/app/components/show-dialogs/show-dialogs.component';
import {StaticSourceDirective} from 'src/app/directives/static-src.directive';
import {MaterialModule} from 'src/app/material/material.module';
import {TextPrettyPipe} from 'src/app/pipes/text-pretty.pipe';
import {MarketplaceManagerService} from 'src/app/services/marketplace-manager.service';
import {SharedFeaturesService} from 'src/app/services/shared-features.service';
import {SubscriptionAppService} from 'src/app/services/subscription-app.service';

@Component({
  selector: 'app-product-details',
  standalone: true,
  imports: [
    MaterialModule,
    TextPrettyPipe,
    TitleCasePipe,
    StaticSourceDirective,
    FormsModule,
  ],
  template: `
    <div mat-dialog-title class="d2c-head">
      <div class="dlg-ico">
        <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor"
             stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="4" width="18" height="13" rx="2"/>
          <path d="M8 21h8M12 17v4"/>
        </svg>
      </div>
      <div class="t">
        <h2>{{ data['soln']['solution_name'] | textpretty | titlecase }}</h2>
        <div class="st">
          {{ data['soln']['user_facing_solution_desc']['subtitle'] }}
        </div>
      </div>
      <button class="dlg-x" [mat-dialog-close]="false" aria-label="Close">
        <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor"
             stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M18 6 6 18M6 6l12 12"/>
        </svg>
      </button>
    </div>

    <div mat-dialog-content class="d2c-body">
      <!-- subscribed state line -->
      <div class="sub-state-row" *ngIf="oldSubscription">
        <span class="sub-state">
          <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor"
               stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
            <path d="M20 6 9 17l-5-5"/>
          </svg>
          Subscribed to {{ oldSubscription.version_name }}
        </span>
      </div>

      <!-- About -->
      <div class="lbl">About</div>
      <div class="desc">
        {{ data['soln']['user_facing_solution_desc']['description'] || 'No description provided for this solution.' }}
      </div>

      <!-- What you get -->
      <ng-container *ngIf="features?.length">
        <div class="lbl">What you get</div>
        <div class="feat">
          <div class="f" *ngFor="let feature of features; let i = index">
            <span class="fi">
              <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor"
                   stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
                <path d="M20 6 9 17l-5-5"/>
              </svg>
            </span>
            <span class="break-normal whitespace-normal">{{ feature }}</span>
          </div>
        </div>
      </ng-container>

      <!-- media carousel (only if real media exists) -->
      <div class="media-wrap" *ngIf="itemsLinks?.length">
        <button class="media-nav" (click)="showPrevItem()" aria-label="Previous">
          <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor"
               stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M15 6l-6 6 6 6"/>
          </svg>
        </button>
        <div
          *ngFor="let item of itemsLinks; let i = index"
          [ngClass]="{ hidden: currentIndex !== i }"
        >
          <video
            width="600"
            height="320"
            controls
            *ngIf="item.type === 'video' && item.src != ''"
          >
            <source [src]="item.src" type="video/mp4"/>
          </video>
          <img
            width="600"
            height="320"
            alt="image"
            *ngIf="item.type === 'image' && item.src != ''"
            [src]="item.src"
          />
        </div>
        <button class="media-nav" (click)="showNextItem()" aria-label="Next">
          <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor"
               stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M9 6l6 6-6 6"/>
          </svg>
        </button>
      </div>

      <!-- Version + key -->
      <div class="lbl">{{ oldSubscription ? 'Change version' : 'Subscribe' }}</div>
      <div class="row2">
        <div class="fld">
          <div class="fld-lbl">Version</div>
          <mat-form-field appearance="outline" class="box-field">
            <mat-select
              [(ngModel)]="selectedVersion"
              [compareWith]="compareFn"
            >
              <mat-select-trigger>
                {{ selectedVersion?.['version_name'] }} &mdash; {{ selectedVersion?.updated_dtm | date : 'dd MMM yyyy' }}
              </mat-select-trigger>
              <mat-option
                [value]="version"
                *ngFor="let version of versions"
                [disabled]="
                  oldSubscription?.version_id === version.version_id
                "
              >
                <div class="ver-opt">
                  <span class="ver-name">Version: {{ version['version_name'] }}</span>
                  <span class="ver-date">Release Date: {{ version.updated_dtm | date : 'dd MMM yyyy' }}</span>
                </div>
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div
          class="fld"
          *ngIf="checkAndUpdate(selectedVersion) == 'Subscribe'"
        >
          <div class="fld-lbl">Subscription key</div>
          <mat-form-field appearance="outline" class="box-field">
            <input matInput [(ngModel)]="subscriptionKey" placeholder="Paste the key from your provider"/>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div mat-dialog-actions class="d2c-foot">
      <span class="note">
        {{ oldSubscription
          ? 'Upgrade to a newer version, or roll back to a previous one.'
          : 'A subscription key is provided by the solution publisher.' }}
      </span>
      <div class="foot-btns">
        <button class="btn-ghost" [mat-dialog-close]="false">Cancel</button>
        <button
          class="btn-primary"
          [disabled]="
            oldSubscription?.version_id === selectedVersion.version_id ||
            (checkAndUpdate(selectedVersion) == 'Subscribe' &&
              subscriptionKey === '')
          "
          (click)="subscribe(selectedVersion)"
        >
          {{ checkAndUpdate(selectedVersion) }}
        </button>
      </div>
    </div>
  `,
  styles: [`
    :host {
      --brand: #E60000;
      --brand-d: #B80000;
      --ink: #1A1A1A;
      --muted: #6B7280;
      --line: #E5E7EB;
      --green: #16A34A;
      display: block;
      font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, Arial, sans-serif;
      color: var(--ink);
      max-width: 720px;
    }

    /* header */
    .d2c-head {
      display: flex;
      align-items: flex-start;
      gap: 16px;
      padding: 22px 24px 18px;
      border-bottom: 1px solid var(--line);
      margin: 0;
    }
    .d2c-head .dlg-ico {
      width: 54px;
      height: 54px;
      border-radius: 13px;
      background: #feecec;
      color: var(--brand);
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }
    .d2c-head .t { flex: 1; min-width: 0; }
    .d2c-head .t h2 { font-size: 20px; font-weight: 700; margin: 0; line-height: 1.3; }
    .d2c-head .t .st { color: var(--muted); font-size: 13.5px; margin-top: 4px; }
    .d2c-head .dlg-x {
      color: var(--muted);
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      border: none;
      background: transparent;
      padding: 4px;
      border-radius: 8px;
    }
    .d2c-head .dlg-x:hover { background: #F3F4F6; color: var(--ink); }

    /* body */
    .d2c-body { padding: 22px 24px; }
    .lbl {
      font-size: 12px;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: .4px;
      color: var(--muted);
      margin-bottom: 8px;
    }
    .desc { font-size: 14px; line-height: 1.6; color: #374151; margin-bottom: 20px; }

    .sub-state-row { margin-bottom: 18px; }
    .sub-state {
      display: inline-flex;
      align-items: center;
      gap: 7px;
      background: #E8F6EE;
      color: var(--green);
      font-size: 13px;
      font-weight: 700;
      border-radius: 8px;
      padding: 9px 14px;
    }

    .feat { display: flex; flex-direction: column; gap: 8px; margin-bottom: 20px; }
    .feat .f { display: flex; align-items: center; gap: 10px; font-size: 13.5px; }
    .feat .fi {
      width: 22px;
      height: 22px;
      border-radius: 6px;
      background: #E8F6EE;
      color: var(--green);
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }

    .media-wrap {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 12px;
      margin-bottom: 20px;
    }
    .media-nav {
      width: 36px;
      height: 36px;
      border-radius: 9px;
      border: 1px solid var(--line);
      background: #fff;
      color: var(--muted);
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
    .media-nav:hover { background: #fafafa; }
    .hidden { display: none; }

    .row2 {
      display: grid;
      grid-template-columns: 280px 1fr;
      gap: 16px;
      align-items: start;
      margin-bottom: 6px;
    }
    .fld { min-width: 0; }
    .fld-lbl {
      font-size: 12.5px;
      font-weight: 600;
      color: #374151;
      margin-bottom: 6px;
    }
    .box-field { width: 100%; }

    .ver-opt { display: flex; flex-direction: column; padding: 4px 0; }
    .ver-opt .ver-name { font-weight: 600; font-size: 13px; }
    .ver-opt .ver-date { color: var(--muted); font-size: 12px; }

    /* footer */
    .d2c-foot {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 10px;
      padding: 16px 24px;
      border-top: 1px solid var(--line);
      background: #FCFCFD;
      margin: 0;
    }
    .d2c-foot .note { font-size: 12.5px; color: var(--muted); }
    .foot-btns { display: flex; gap: 10px; flex-shrink: 0; }

    .btn-primary {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      background: var(--brand);
      color: #fff;
      border: none;
      border-radius: 9px;
      padding: 10px 18px;
      font-size: 14px;
      font-weight: 600;
      cursor: pointer;
      font-family: inherit;
    }
    .btn-primary:hover { background: var(--brand-d); }
    .btn-primary:disabled { background: #E5E7EB; color: #9AA0A6; cursor: not-allowed; }

    .btn-ghost {
      display: inline-flex;
      align-items: center;
      gap: 7px;
      background: #fff;
      color: #374151;
      border: 1px solid var(--line);
      border-radius: 9px;
      padding: 10px 16px;
      font-size: 14px;
      font-weight: 600;
      cursor: pointer;
      font-family: inherit;
    }
    .btn-ghost:hover { background: #fafafa; border-color: #d1d5db; }

    /* box the mat-select + key input: single flat bordered control,
       no floating label / notched outline */
    :host ::ng-deep .box-field .mdc-notched-outline__leading,
    :host ::ng-deep .box-field .mdc-notched-outline__notch,
    :host ::ng-deep .box-field .mdc-notched-outline__trailing {
      border: none;
    }
    :host ::ng-deep .box-field .mat-mdc-text-field-wrapper {
      background: #fff;
      border: 1px solid var(--line);
      border-radius: 10px;
      padding: 0 12px;
      transition: border-color .15s, box-shadow .15s;
    }
    :host ::ng-deep .box-field:hover .mat-mdc-text-field-wrapper {
      border-color: #d1d5db;
    }
    :host ::ng-deep .box-field.mat-focused .mat-mdc-text-field-wrapper {
      border-color: var(--brand);
      box-shadow: 0 0 0 3px rgba(230, 0, 0, .08);
    }
    :host ::ng-deep .box-field .mat-mdc-form-field-infix {
      padding-top: 10px;
      padding-bottom: 10px;
      min-height: unset;
    }
    :host ::ng-deep .box-field .mat-mdc-select-value,
    :host ::ng-deep .box-field .mat-mdc-input-element {
      font-size: 14px;
      color: var(--ink);
    }
    :host ::ng-deep .box-field .mat-mdc-form-field-focus-overlay { background: transparent; }
    :host ::ng-deep .box-field .mat-mdc-select-arrow { color: var(--muted); }
    :host ::ng-deep .box-field.mat-focused .mat-mdc-select-arrow { color: var(--brand); }
    :host ::ng-deep .box-field .mat-mdc-form-field-subscript-wrapper { display: none; }
  `],
})
export class ProductDetailsComponent implements OnInit {
  features: any;
  videoLink: any = false;
  imagesLinks: any = false;
  itemsLinks: any = [];
  currentIndex: number = 0;
  oldSubscription: any = false;
  versions: any = [];
  selectedVersion: any;
  subscriptionKey = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private subscriptionServices: SubscriptionAppService,
    private snackBar: SharedFeaturesService,
    private marketplaceServices: MarketplaceManagerService,
    private dialog: MatDialog
  ) {
  }

  ngOnInit(): void {
    this.fetchSubscription();
    this.getAllVersionOfCurrentSolution();
    this.selectedVersion = this.data.versn;
    this.videoLink = this.data.soln.user_facing_solution_desc.videoLink;
    if (this.videoLink)
      this.itemsLinks.push({type: 'video', src: this.videoLink});
    this.imagesLinks = this.data.soln.user_facing_solution_desc.images;
    const images = this.data.soln.user_facing_solution_desc.images;
    if (images) {
      this.imagesLinks = Object.values(images);
      this.imagesLinks.forEach((element: string) => {
        this.itemsLinks.push({type: 'image', src: element});
      });
    }
    const appFeature = this.data.soln.user_facing_solution_desc.feature;
    if (appFeature) {
      this.features = Object.values(appFeature);
    }
  }

  compareFn(option1: any, option2: any) {
    return option1 && option2
      ? option1.version_id === option2.version_id
      : false;
  }

  fetchSubscription() {
    this.subscriptionServices
      .getSubscribedSolutionsBySolutionId(this.data.soln.solution_id)
      .subscribe({
        next: (response: any) => {
          this.oldSubscription = response.msg[0];
        },
      });
  }

  checkAndUpdate(version: any): string {
    if (!version || !this.oldSubscription) return 'Subscribe';

    const parseVersion = (versionString: string) =>
      +versionString.replace('V', '');

    const currentVersion = parseVersion(version.version_name);
    const oldVersion = parseVersion(this.oldSubscription.version_name);

    if (currentVersion > oldVersion) {
      return 'Update';
    } else if (currentVersion < oldVersion) {
      return 'RollBack';
    } else {
      return 'Subscribed';
    }
  }

  showNextItem() {
    this.currentIndex = (this.currentIndex + 1) % this.itemsLinks.length;
  }

  showPrevItem() {
    this.currentIndex =
      (this.currentIndex - 1 + this.itemsLinks.length) % this.itemsLinks.length;
  }

  getAllVersionOfCurrentSolution() {
    this.marketplaceServices
      .getVersionsFromMarketOfSolution(this.data.soln['solution_id'])
      .subscribe({
        next: (response: any) => {
          this.versions = response['msg'];
          this.versions.sort((a: any, b: any) => {
            const versionA = parseInt(a.version_name.substr(1));
            const versionB = parseInt(b.version_name.substr(1));
            return versionB - versionA;
          });
        },
      });
  }

  subscribe(version: any) {
    const data: any = {
      solution_id: this.data.soln['solution_id'],
      subscription_key: this.subscriptionKey,
      solution_name: this.data.soln['solution_name'],
      version_id: version['version_id'],
      version_name: version['version_name'],
      no_of_users: 100,
      duration: 12,
    };

    if (!this.oldSubscription) {
      this.subscriptionServices.subscribeSolution(data).subscribe({
        next: (response: any) => {
          this.fetchSubscription();
          this.snackBar.openSnackBar(
            response['msg'],
            'Close',
            'success-snackbar'
          );
        },
        error: (error: any) => {
          this.snackBar.openSnackBar(
            error?.error?.msg || error?.message,
            'Close',
            'error-snackbar'
          );
        },
      });
    } else if (this.oldSubscription) {
      const isRollback = this.checkAndUpdate(version) === 'RollBack';
      const ref = this.dialog.open(ShowDialogsComponent, {
        data: {
          title: isRollback
            ? 'Roll back to ' + version['version_name'] + '?'
            : 'Update to ' + version['version_name'] + '?',
          message: isRollback
            ? 'Your subscription will switch from ' +
              this.oldSubscription.version_name +
              ' back to ' +
              version['version_name'] +
              '. Users and schedules move to the older version.'
            : 'Your subscription will move from ' +
              this.oldSubscription.version_name +
              ' to ' +
              version['version_name'] +
              '.',
          confirmText: isRollback ? 'Roll back' : 'Update',
          cancelText: 'Cancel',
          danger: isRollback,
        },
        disableClose: false,
      });
      ref.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.doUpdateSubscription(data);
        }
      });
    }
  }

  private doUpdateSubscription(data: any) {
    this.subscriptionServices
      .updateSubscription(this.oldSubscription, data)
      .subscribe({
        next: (response: any) => {
          this.fetchSubscription();
          this.snackBar.openSnackBar(
            response['msg'],
            'Close',
            'success-snackbar'
          );
        },
        error: (error: any) => {
          this.snackBar.openSnackBar(
            error?.error?.msg || error?.message,
            'Close',
            'error-snackbar'
          );
        },
      });
  }
}
